import styled, { css } from 'styled-components';
import {
  PADDING,
  REBRAND_COLOR,
  REBRAND_GRADIENT,
  BREAKPOINT
} from '@latitude/core/utils/constants';
import Section from '@latitude/section-rebrand';

export const Wrapper = styled.div`
  background: ${REBRAND_COLOR.STONE};
`;

export const StyledPopCollectionContainer = styled(Section)`
  padding-top: ${PADDING.P64};
  padding-bottom: ${PADDING.P64};
  display: flex;
  flex-direction: column;
  gap: 32px;
  @media (min-width: ${BREAKPOINT.MD}) {
    padding-top: ${PADDING.P80};
    padding-bottom: ${PADDING.P80};
    gap: 64px;
  }
`;

export const StyledPopContentContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
`;
